import { Module } from 'vuex'
import { blankResponseArray } from '../constants'
import { RootState } from '../types'
import { actions } from './actions'
import { mutations } from './mutations'
import State from './types'
import { blankSalesRep, blankSearchFilters } from './constants'
import { getters } from './getters'
import _ from 'lodash'

export const state: State = {
  error: false,
  page: 1,
  pageSize: 8,
  salesReps: blankResponseArray,
  preloaded: false,
  activeSalesRep: blankSalesRep,
  loading: false,
  errorMessage: '',
  searchFilters: _.cloneDeep(blankSearchFilters),
}

const namespaced = true

export const salesReps: Module<State, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
}
